export default __webpack_public_path__ + "static/distribution-histogram-time-to-convert-light-mode-8adf9ffb206b3d6b33216ac322aa737b.png";